import { useNavigate } from '@tanstack/react-router';
import { Card } from '@/components/ui/Card.tsx';
import InitialsAvatar from '@/components/ui/InitialsAvatar.tsx';
import Chip from '@/components/ui/Chip.tsx';
import ActionButton from '@/components/buttons/ActionButton.tsx';
import UserAccessDto from '@/features/auth/login/types/UserAccessDto.ts';
import { getRoleLabel } from '@/features/auth/login/types/Role.utils.ts';
import { storeCompanyId } from '@/features/dashboard/_root/access/currentCompany.ts';
import { companyInitials } from '@/features/auth/workspaces/utils/companyInitials.ts';
import { queryClient } from '@/App.tsx';

const WorkspaceCompanyCard = ({
  access,
  current,
}: {
  access: UserAccessDto;
  current: boolean;
}) => {
  const navigate = useNavigate();
  const enter = () => {
    storeCompanyId(access.companyId);
    // Cache trzyma dane poprzedniej firmy — po zmianie tenanta wszystko ma się pobrać od nowa.
    queryClient.clear();
    navigate({ to: '/app' });
  };
  return (
    <Card highlighted={current} className="flex w-full items-center gap-3 p-4">
      <InitialsAvatar
        tone="accent"
        initials={companyInitials(access.companyName)}
      />
      <div className="flex min-w-0 flex-1 flex-col gap-1">
        <span className="truncate font-semibold text-base-text">
          {access.companyName}
        </span>
        <Chip label={getRoleLabel(access.role)} />
      </div>
      <ActionButton
        tone={current ? 'accent' : 'outline'}
        size="sm"
        onClick={enter}
      >
        Wejdź
      </ActionButton>
    </Card>
  );
};

export default WorkspaceCompanyCard;
